import { useState } from 'react';
import { Property } from '../../types/user';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';
import { Button } from '../ui/Button';
import { createUser } from '../../services/users';
import toast from 'react-hot-toast';

interface CreateUserFormProps {
  properties: Property[];
  onUserCreated: () => void;
}

export const CreateUserForm = ({ properties, onUserCreated }: CreateUserFormProps) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    propertyId: ''
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      await createUser(
        formData.email,
        formData.password,
        formData.name,
        'owner',
        formData.propertyId || undefined
      );
      
      toast.success('Usuario creado exitosamente');
      setFormData({ name: '', email: '', password: '', propertyId: '' });
      onUserCreated();
    } catch (error: any) {
      console.error('Error al crear usuario:', error);
      // Mostrar un mensaje de error más específico si está disponible
      const errorMessage = error.message || 'Error al crear el usuario';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <Input
        label="Nombre completo"
        value={formData.name}
        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        placeholder="Ej: Juan Pérez"
        required
      />

      <Input
        label="Email"
        type="email"
        value={formData.email}
        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        placeholder="usuario@ejemplo.com"
        required
      />

      <Input
        label="Contraseña"
        type="password"
        value={formData.password}
        onChange={(e) => setFormData({ ...formData, password: e.target.value })}
        placeholder="Mínimo 6 caracteres"
        required
        minLength={6}
      />

      <Select
        label="Propiedad asignada"
        value={formData.propertyId}
        onChange={(e) => setFormData({ ...formData, propertyId: e.target.value })}
        options={[
          { value: '', label: 'Sin propiedad asignada' },
          ...properties.map(property => ({
            value: property.id,
            label: property.name
          }))
        ]}
      />

      <Button
        type="submit"
        loading={loading}
        className="w-full"
      >
        Crear Usuario
      </Button>
    </form>
  );
};
